// * PHOTOUPLOAD STORE MODULE
const docViewer_store = {
    namespaced: true,
    // * STATE
    state: {
        docViewer: {
            fileType: '',
            fileURL: '',
        },
    },
    // * MUTATIONS
    mutations: {
        MUT_docViewer(state, data) { state.docViewer = data },
    },
    // * GETTERS
    getters: {
        GET_docViewer(state) { return state.docViewer },
    },
    // * ACTIONS
    actions: {
        ACT_docViewer({commit}, payload){ commit('MUT_docViewer', payload) },
    }    

};
export default docViewer_store;
